import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Descope } from '@descope/react-sdk';
import config from '../config';
import { authStore } from '../utils/authStore';
const LoginComponent = () => {
    return (_jsx("div", { className: "login-container", children: _jsx(Descope, { flowId: config.descopeFlowId, theme: config.descopeTheme, onSuccess: (e) => {
                console.log('Login successful!');
                if (e.detail.user) {
                    console.log('User name:', e.detail.user.name);
                    console.log('User email:', e.detail.user.email);
                    // Save user data to persistent storage
                    authStore.saveAuthData({
                        user: e.detail.user,
                    });
                    console.log('🔐 User data saved to persistent storage');
                }
            }, onError: (err) => {
                console.log("Login error!", err);
            } }) }));
};
export default LoginComponent;
